import tokenClient from "./tokenClient/tokenClient";
import protectedClient from "./protectedClient";
import {AdminApi } from "../constants";

const handleUnauthorized = () => {
  localStorage.removeItem("tokenExpireAt");
  localStorage.removeItem("refreshTokenExpireAt");
  localStorage.removeItem("phoneNumber");
  window.location.href = "/login";
};

export const protectedApiRequest = async (apiFunction) => {
  try {
    const response = await apiFunction();
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      handleUnauthorized();
      return null;
    }
    console.error("Något gick fel.");
    return null;
  }
};

export const protectedApiRequestV2 = async (apiFunction) => {
  try {
    const response = await apiFunction();
    return response.data;
  } catch (error) {
    handleUnauthorized();
    return null;
  }
};

export const postPasscode = async (phoneNumber, verificationCode) => {
  try {
    const bodyObject = {
      phoneNumber,
      verificationCode,
    };

    const response = await protectedClient.post(
      AdminApi.POST_IDENTITY_PASSCODE,
      bodyObject
    );
    if (response.status === 200) {
      localStorage.setItem("tokenExpireAt", response.data.tokenExpireDateTime);
      localStorage.setItem(
        "refreshTokenExpireAt",
        response.data.refreshTokenExpireDateTime
      );
      localStorage.setItem("phoneNumber", phoneNumber);
    }

    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    } else {
      return null;
    }
  }
};

export const loginRefresh = async () => {
  try {
    const response = await tokenClient.post("/api/identity/login/refresh");
    localStorage.setItem("tokenExpireAt", response.data.tokenExpireDateTime);
    localStorage.setItem(
      "refreshTokenExpireAt",
      response.data.refreshTokenExpireDateTime
    );
  } catch (error) {
    if (error.response && error.response.status === 401) {
      handleUnauthorized();
    }
  }
};

